export default __webpack_public_path__ + "static/media/enter.5b1a071c.svg";